<template>
    <a
        class="book-appointment"
        :class="variant"
        target="_blank"
        rel="noopener noreferrer"
        :href="agent.calendarLink"
        v-if="agent.calendarLink"
        title="book appointment"
        :style="compStyles"
        @click.stop
    >
        <span class="iconfont icon-calendar" v-if="variant !== 'arrow'"></span>
        <span class="text">{{ $t('md-team.bookAppointment') }}</span>
        <i v-if="showArrow" class="iconfont icon-arrow_06_right"></i>
        <template v-else>
            <span
                class="iconfont icon-arrow_01_right"
                v-if="variant == 'link'"
            ></span>
            <span class="iconfont icon-arrow-up" v-if="variant == 'arrow'">
            </span>
        </template>
    </a>
</template>

<script>
export default {
    i18next: {
        ns: 'md-team'
    },
    props: {
        variant: {
            type: String,
            default: 'button' // button , link , arrow
        },
        agent: {
            type: Object,
            default: null
        },
        fontSize: {
            type: String,
            default: null
        },
        btnColor: {
            type: String,
            default: ''
        },
        theme: {
            type: String,
            default: ''
        },
        showArrow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        compStyles() {
            let styleObj = {
                '--base-font-size': this.fontSize
            };
            if (this.btnColor) {
                styleObj.color = this.btnColor;
            }
            return styleObj;
        }
    },
    mounted() {}
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.book-appointment {
    cursor: pointer;
    display: inline-block;
    font-size: var(--base-font-size, '16px');
    font-family: var(--font-medium);
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    .icon-calendar {
        margin-right: 8px;
    }
    &.button {
        @include color-button-hover();
        color: var(--mg-button-color);
        background-color: var(--mg-button-background);
        padding: 7px 15px;
    }
    &.link {
        color: var(--color-theme);
        &:hover {
            color: var(--color-hover);
            text-decoration: underline;
        }
        .icon-arrow_01_right {
            font-size: 10px;
            &::before {
                margin-left: 8px;
            }
        }
    }
    .icon-arrow_06_right {
        margin-left: 10px;
        font-size: 16px;
    }
}
</style>
